import React from 'react';
import RaiseRightLogo from '../../media/images/LogoIconLightBg.svg';
import { createStyles } from 'utils/createStyle';

const Loading = () => {
    const loadingStyles = createStyles({
        loadingContainer:
            'flex flex-col h-screen w-full mx-auto bg-white fixed top-0 bottom-0 left-0 right-0 items-center justify-center',
        loadingContent: 'text-center',
        loadingLogo: [
            'w-48 h-48 mx-auto opacity-85 animate-pulse',
            { animationDuration: '3s', marginBottom: '40px' },
        ],
        loadingTitle: 'text-4xl font-semibold mb-3 text-brand-dark',
        loadingText: ['text-base text-grey-medium leading-8', { fontSize: '20px' }],
    });

    return (
        <div className={loadingStyles.loadingContainer}>
            <div className={loadingStyles.loadingContent}>
                <div>
                    <img
                        className={loadingStyles.loadingLogo}
                        src={RaiseRightLogo}
                        alt="Raise Right Logo"
                        width="180"
                        height="180"
                    />
                </div>

                <h1 className={loadingStyles.loadingTitle}>We're preparing your gifts</h1>

                <p className={loadingStyles.loadingText}>
                    In a few moments this window will close and
                </p>

                <p className={loadingStyles.loadingText}>
                    your gifts will be added into your cart.
                </p>
            </div>
        </div>
    );
};

export default Loading;
